import React, {Component} from "react"
import {connect} from "react-redux";
import withStyles from "@mui/styles/withStyles";
import {withRouter} from "react-router-dom";
import {Box, Paper} from "@mui/material";
import Typography from "@mui/material/Typography";

const styles = {
    paper: {
        margin: 15,
        padding: 15
    },

    root: {
        minHeight: "calc(100vh - 86px)",
        position: "relative"
    },

};


class Contact extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const {classes} = this.props;
        // todo kontaktný formulár (Name, Surname, E-mail, Subject, Message – všetky polia povinné a odoslanie na e-mailovú adresu: voca.click_support@ed-corporation.com)
        //        <br/><br/><br/>[TU BUDE KONTAKTNY FORMULAR (Name, Surname, E-mail, Subject, Message)]
        return (<Box className={classes.root}>
            <Paper className={classes.paper} style={{background: this.props.theming.darkMode ? "black" : "white"}}>
                <Typography variant={"h5"} gutterBottom={true}>Contact</Typography>
                <Typography>
                    You can contact VOCA.CLICK support via phone number 00421-950-341111 or via e-mail address
                    office@ed-corporation.com. We will reply to your enquiry as soon as
                    possible, generally during the two working days.
                </Typography>
            </Paper></Box>)
    }
}

const mapStateToProps = state => ({
    theming: state.theming
});

export default withRouter(withStyles(styles)(connect(
    mapStateToProps,
    {}
)(Contact)));
